import {
  keepPreviousData,
  useQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { trackEventsApi } from "../services/api";

export const useTrackEvents = (
  filters: { page?: number; page_size?: number; search?: string } = {},
) => {
  return useQuery({
    queryKey: ["track-events", filters],
    queryFn: () => trackEventsApi.list(filters),
    placeholderData: keepPreviousData,
  });
};

export const useScriptTrackEvents = (scriptId: number) => {
  return useQuery({
    queryKey: ["script-track-events", scriptId],
    queryFn: () => trackEventsApi.getForScript(scriptId),
    enabled: !!scriptId,
  });
};

export const useUpdateScriptTrackEvents = (scriptId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (trackEventIds: number[]) =>
      trackEventsApi.setForScript(scriptId, trackEventIds),

    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: ["script-track-events", scriptId],
      });
    },
  });
};
